/**
 * The summary's type fits its box (2026-10-29). The Studio lets a Mystic make
 * a summary very short or very long; at one fixed size a short one sat small
 * beside the illustration. The size now follows two things:
 *
 *   - its length, here: SUMMARY_MAX_PX for a summary of SHORT_CHARS or fewer,
 *     stepping down to SUMMARY_MIN_PX at LONG_CHARS and beyond;
 *   - its box's width, in SpreadReading's CSS: `.sr-syn` is a size container
 *     and the paragraph's `clamp(17px, n*0.7px + n*0.0556cqi, n*1px)` reaches
 *     the length's size at a ~540px box (the 1440 layout) and eases down on a
 *     narrower one (about 21px at 390 for a short summary), never under 17px.
 *
 * The size rides as a unitless CSS variable, `--syn-n`.
 */
export const SUMMARY_MIN_PX = 17
export const SUMMARY_MAX_PX = 24
const SHORT_CHARS = 160
const LONG_CHARS = 1100

export function summaryTypeSize(text) {
  const n = String(text || '').trim().length
  if (n <= SHORT_CHARS) return SUMMARY_MAX_PX
  if (n >= LONG_CHARS) return SUMMARY_MIN_PX
  const t = (n - SHORT_CHARS) / (LONG_CHARS - SHORT_CHARS)
  return Math.round(SUMMARY_MAX_PX - t * (SUMMARY_MAX_PX - SUMMARY_MIN_PX))
}

export function summaryFitStyle(text) {
  return { '--syn-n': String(summaryTypeSize(text)) }
}
